var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-info noShorex"},[_c('div',{staticClass:"product-title"},[_vm._v("岸上观光服务")]),_c('div',{staticClass:"product-shorex-tips"},[_c('div',{staticClass:"shorex-tips-left"}),_c('p',[_vm._v("您可以在支付完成后界面选择岸上观光服务，或在船票预订完成后前往皇家行前订网站小程序选订。"),_c('br'),_vm._v(" 您也可以不选订任何行程则视为自助游，您需自行安排目的地游览行程。")])])])
}]

export { render, staticRenderFns }